module.exports = __webpack_public_path__ + "img/preika_black.9d9304ea.png";